const constants = {
  primary: "#BCBCBC",
  seconday: "#D9D9D9",
  tertiary: "#fe8d01",
  table: "#ededed",
};

export default constants;